#import "@/components/common/EntryReferenceFragment.gql"

fragment CopyTextFragment on copyText_Entry {
  typeHandle
  id
  body
  relatedImage {
    url
    title
  }
  related {
    ...EntryReferenceFragment
  }
  relatedCaption
}
